export const researchReview = {
  "moduleId": "research",
  "title": "讀懂資料，再比較基金",
  "questions": [
    {
      "id": "research-review-1",
      "lessonId": "index-weighting",
      "question": "同一份完整成分名單，甲依市值配置、乙採等權重；可以只由名單推定本期報酬相同嗎？",
      "options": [
        "不行，還要看期初權重與各成分報酬",
        "可以，只要成分檔數相同",
        "可以，權重只影響交易費"
      ],
      "answer": 0,
      "explanation": "同一家公司占比不同，就會對組合報酬產生不同貢獻。"
    },
    {
      "id": "research-review-2",
      "lessonId": "fund-overlap",
      "question": "A 占組合 40%、其中甲占 30%；B 占 60%、其中甲占 10%。甲的合併權重是多少？",
      "options": [
        "12%",
        "18%",
        "40%"
      ],
      "answer": 1,
      "explanation": "40%×30%＋60%×10%＝18%，不是把兩檔基金內部權重直接相加。"
    },
    {
      "id": "research-review-3",
      "lessonId": "fund-documents",
      "question": "一份月報只列前五大，合計 55%。還有多少權重沒有在這份摘要列出？",
      "options": [
        "0%，因為前五大就是全部",
        "55%，等於已列的持股",
        "45%，仍需要完整資料才能分析全部"
      ],
      "answer": 2,
      "explanation": "100%−55%＝45%；未列示不代表無持有，也不應把已知部分擴大到100%。"
    },
    {
      "id": "research-review-4",
      "lessonId": "benchmark-comparison",
      "question": "同期間、同幣別下，基金淨值漲 2%，另有相當於期初淨值 1% 的期末配息未再投入；基準含息報酬 4%。不計其他費稅，差額為多少？",
      "options": [
        "−2 個百分點",
        "−1 個百分點",
        "＋1 個百分點"
      ],
      "answer": 1,
      "explanation": "基金總報酬2%＋1%＝3%，基金減基準3%−4%＝−1個百分點。"
    }
  ]
};
